import { Slot, TrainerListItem, TrainerPublicPage } from "./api";

export interface GlobalSlot extends Slot {
  trainerName: string;
  price: string | null;
}

export type PartOfDay = "утро" | "день" | "вечер";

export function partOfDay(iso: string): PartOfDay {
  const hour = new Date(iso).getUTCHours();
  if (hour < 12) return "утро";
  if (hour < 17) return "день";
  return "вечер";
}

export function groupByDay(slots: GlobalSlot[]): [string, GlobalSlot[]][] {
  const byDay = new Map<string, GlobalSlot[]>();
  for (const slot of [...slots].sort((a, b) => a.start_at.localeCompare(b.start_at))) {
    const day = slot.start_at.slice(0, 10);
    if (!byDay.has(day)) byDay.set(day, []);
    byDay.get(day)!.push(slot);
  }
  return Array.from(byDay.entries());
}

// GET /venues requires auth and (without trainer_id) scopes to the caller's own venues — not
// usable for an anonymous, cross-trainer venue map. /trainers/{id}/public-page is public and
// already carries {id, name}, so the venue map for the home page is derived from it instead.
export async function loadVenueMap(
  api: { get: <T>(path: string) => Promise<T> },
  trainers: TrainerListItem[]
): Promise<Map<string, string>> {
  const pages = await Promise.all(
    trainers.map((t) => api.get<TrainerPublicPage>(`/trainers/${t.user_id}/public-page`).catch(() => null))
  );
  const map = new Map<string, string>();
  for (const page of pages) {
    if (!page) continue;
    for (const v of page.venues) map.set(v.id, v.name);
  }
  return map;
}

export async function loadWeekSchedule(
  api: { get: <T>(path: string) => Promise<T> },
  trainers: TrainerListItem[]
): Promise<GlobalSlot[]> {
  const results = await Promise.all(
    trainers.map(async (t) => {
      const slots = await api.get<Slot[]>(`/schedule/${t.user_id}?days_ahead=7`).catch(() => []);
      return slots
        .filter((s) => s.status === "available")
        .map((s) => ({ ...s, trainerName: t.display_name, price: t.min_price }));
    })
  );
  return results.flat();
}
